import React from "react";
import Glimmer from "@components/Glimmer";

const AppointmentTileGlimmer = () => <Glimmer height={167} width={167} />;

export default React.memo(AppointmentTileGlimmer);
